const useRedirectToAndroidApp = () => {
  const redirectToAndroid = async (softpayAppId: string) => {
    const intentURL = `intent://softpayappid#Intent;scheme=softpayappid;package=com.favrit.favritsoftpay;action=android.intent.action.VIEW;S.json={"softpayAppId": "${softpayAppId}"};end`;
    window.location.href = intentURL;
  };

  return {
    redirectToAndroid,
  };
};

export default useRedirectToAndroidApp;
